<header class="mb-3">
  <p class="mb-0"><b>Inventario:</b> {{ inventoryName }}</p>
</header>
<section class="table-container">
  <app-custom-table [showRecover]="true" [headers]="header" [data]="data" [actions]="tableActions"
    [previousFilters]="filters" [isFilterPersistent]="false" (onRecoverData)="getAllInventoryUsersWithPagination()"
    (onAction)="onAction($event)" (onPageChange)="onPageChange($event)" (onFilterChange)="onFilterChange($event)">
  </app-custom-table>
</section>